import { useNavigate } from "react-router-dom";
import { ChevronLeft, LogOut } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import AdminModeToggle from "@/components/AdminModeToggle";

import { Button } from "@/components/ui/button";

import cryptoFellas from "@/assets/fellas.svg";

export default function Header({
  showLogo = true,
  showBack = false,
  onBackClick,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-background z-50 p-4">
      <div className="max-w-lg mx-auto">
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {showBack && (
                <button
                  onClick={handleBack}
                  className="flex items-center gap-1 text-xs text-foreground hover:underline w-fit"
                >
                  <ChevronLeft className="w-6 h-6" />
                </button>
              )}
              {showLogo ? (
                <div
                  className="flex flex-col items-start cursor-pointer"
                  onClick={() => navigate("/")}
                >
                  <img
                    src={cryptoFellas}
                    alt="CryptoFellas Card"
                    className="w-auto h-6"
                  />
                  <h1 className="ml-[3px] text-md font-bold text-foreground">
                    Membership Card
                  </h1>
                </div>
              ) : (
                <div> </div>
              )}
            </div>
            {/* Theme Toggle and Admin Mode */}
            <div className="flex items-center gap-2">
              <AdminModeToggle />
              <ThemeToggle />

              {/* Logout */}
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate("/logout")}
              >
                <LogOut className="h-[1.2rem] w-[1.2rem]" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
